<template>
  <div v-if="info !== null" class="main">
    <div style="position: relative;" class="main-box">
      <div class="back" :style="{ background: theme_color_bg }"></div>
      <div class="content">
        <div class="content-top">
          <div class="usersInfo">
            <img :src="result.avatar" class="avatar" />
            <div class="name">
              <div>{{ result.uname }}</div>
              <img
                class="pointer"
                @click="toMessage"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-12-03/d3d304eda78cdfc104699edfa3d1ed42.svg"
                v-if="result.is_me == 1"
              />
            </div>
          </div>
          <div class="content-top-box">
            <div class="title">{{ info.title }}</div>
            <div v-if="info.temp == 3" class="hide-score">
              <img
                class="success-icon"
                src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220517/b9af0e52c75fa6fd574e79c2d68f0e7f.png"
                alt=""
                v-if="info.hide_score || !info.option_score"
              />
              <div class="score" v-else :style="{ color: theme_color }">{{result.score}}</div>
              <div class="tip mt0">提交成功</div>
            </div>
            <div v-else>
              <div class="hide-score" v-if="info.hide_score">
                <img
                  class="success-icon"
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220517/b9af0e52c75fa6fd574e79c2d68f0e7f.png"
                  alt=""
                />
                <div class="tip">提交成功，出题人设置隐藏成绩</div>
              </div>
              <div v-else>
                <div class="score" :style="{ color: theme_color }">
                  {{ result.score }}
                </div>
                <div class="all">满分{{ result.full_score }}分</div>
              </div>
            </div>
            <div class="comment-out">
              <MpBox :info="info"></MpBox>
            </div>
            <div
              class="tools-award position-r"
              :class="{'comAd':  (info.show_comments==1 && info.adv_comment && info.adv_comment.type == 1) || (info.show_comments==1 && info.adv_comment.content)}"
              v-if="info.award_type === 2 && info.awards && info.awards.length"
              @click="toTool()"
            >
              <img class="tools-icon" src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2025-02-24/40b18c811c6b38cb2c71c1f1fa512a25.png" alt="" />
              <div class="tools-name">{{ info.awards[0].title }}</div>
              <label class="tools-lead">前往抽奖 ></label>
            </div>
          </div>
        </div>

        <div class="content-body" v-if="info.temp != 3">
          <div class="detail">
            <div>
              <div class="top">
                <div class="top-view">
                  <div class="big">{{ result.right + result.wrong }}</div>
                  <div class="tip">总题数</div>
                </div>
                <div class="top-view" @click="wrongClick()">
                  <div
                    class="big"
                    :class="{
                      redColor:
                        !info.hide_score && result.wrong && result.wrong > 0
                    }"
                  >
                    {{ info.hide_score ? "-" : result.wrong }}
                  </div>
                  <div class="tip">
                    答错<label
                      style="margin-left: 2px;"
                      v-if="
                        !(!info.wrong_book && show_answer == 1) &&
                          result.wrong > 0
                      "
                      >></label
                    >
                  </div>
                </div>
                <div v-if="info.temp == 2" class="top-view">
                  <div class="big">{{ result.total_days }}天</div>
                  <div class="tip black">累计答题</div>
                </div>
                <div v-else class="top-view">
                  <div class="big black">
                    {{
                      info.hide_score
                        ? "-"
                        : result.right + result.wrong == 0
                        ? 0
                        : (
                            (result.right / (result.right + result.wrong)) *
                            100
                          ).toFixed(1) + "%"
                    }}
                  </div>
                  <div class="tip">正确率</div>
                </div>
                <div class="top-view">
                  <div class="big">{{ result.time }}</div>
                  <div class="tip">用时</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="postop"
          v-if="
            !isInApp &&
              ((!result.exist_blank && !info.has_sub && info.temp != 3) ||
                (result.exist_blank &&
                  result.is_reviewing == 1 &&
                  info.temp != 3))
          "
        >
          <SubBox
            :has_sub="info.has_sub"
            :type="!result.exist_blank ? 0 : info.has_sub ? 2 : 1"
          />
        </div>

        <div
          class="action"
          v-if="info.award_type == 1 && award_run_way && award_run_status != 3"
        >
          <button
            class="button half active"
            style="background:#00cf97"
            @click="toLottery()"
          >
            立即抽奖（{{ result.draws_count }}）
          </button>
        </div>
      </div>
    </div>

    <HomeIcon position="right" />
    <div class="footer" v-if="result">
      <button class="foot-item share" @click="share">
        <img
          class="foot-share-icon"
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20230913/9120195b6557fb692358ebdf72394d20.png"
        />
        分享
      </button>
      <template v-if="result.is_me == 0">
        <div class="foot-item second" @click="toIndex" v-if="show_answer != 1">
          更多有趣答题
        </div>
        <div class="foot-item third" @click="toDetail">我也要答题</div>
      </template>
      <template v-else>
        <div
          class="foot-item second"
          :style="{ color: theme_color, borderColor: theme_color }"
          @click="toAnswer"
          v-if="show_answer != 1"
        >
          <template v-if="show_answer == 0 || show_answer == 5">
            {{
              info.temp == 3
                ? "查看我的回答"
                : info.temp == 6
                ? "查看答案"
                : "查看答案与解析"
            }}
          </template>
          <template v-if="show_answer == 2"
            >查看答案</template
          >
          <template v-if="show_answer == 3 || show_answer == 6">{{
            info.temp == 6 ? "查看详情" : "查看解析"
          }}</template>
          <template v-if="show_answer == 4"
            >查看题目</template
          >
        </div>
        <div
          class="foot-item third"
          :style="{ background: theme_color }"
          @click="noChance ? towronglist() : toDo()"
        >
          {{ noChance ? "错题重练" : info.temp == 3 ? "再次参与" : "再答一次" }}
        </div>
      </template>
    </div>
    <template v-if="!isMobile && !isInApp && settingSrc">
      <right-code desc="微信扫一扫，打开小程序参与" :src="settingSrc">
        <div class="rightCode-btn">
          <button class="toCreate" @click="toPcCreate">我也要创建答题</button>
        </div>
      </right-code>
    </template>
    <van-popup
      v-model="shareVisible"
      position="bottom"
      duration="0.1"
      :style="{ background: 'transparent' }"
    >
      <manage-footer
        :info="info"
        :visible="shareVisible"
        @hideVisible="handleShareVisible"
      ></manage-footer>
    </van-popup>
    <van-popup
      v-model="showShareImg"
      :style="{ width: '300px', background: 'transparent' }"
    >
      <div class="shareimg-box">
        <img :src="prurl" alt="" />
        <div v-if="prurl">长按图片保存</div>
      </div>
    </van-popup>
    <van-popup
      v-model="showShare"
      :style="{ borderRadius: '4px 4px 0 0', width: '330px' }"
      closeable
      close-icon="close"
    >
      <div class="h5Link">
        <div class="h5Link-title">答题H5链接</div>
        <div class="h5Link-text" @click="copy">{{ url }}{{ info.qid }}</div>
        <div class="h5Link-tip" v-for="item in h5LinkTips" :key="item">
          <span class="h5Link-tip-text"></span>{{ item }}
        </div>
        <div class="h5Link-tipActive-box" v-if="!info.enterprise_vip">
          <div
            class="h5Link-tipActive"
            v-for="(item, index) in h5LinkTipsActive"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
        <div
          class="h5Link-btn"
          v-clipboard:copy="url + info.qid"
          v-clipboard:success="copySuccess"
          @click="copy"
        >
          一键复制H5链接
        </div>
      </div>
    </van-popup>
    <van-popup
      v-model="showVersionTip"
      :style="{ borderRadius: '8px', width: '320px' }"
      closeable
      close-icon="close"
      @closed="showVersionTip = false"
    >
      <ImgDialog :src="settingSrc" />
    </van-popup>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import { Toast, Dialog } from "vant";
import {
  getToken,
  formatMinuteNew,
  setShareInfo,
  showModelTips,
  formatDate,
  isMobile,
  getDetailWxCode,
  jumpWrongList,
  adClickReport,
  getWxUrl,
  isWeixin,
  randomString
} from "@/utils/common";
import MpBox from "@/components/mpBox";
import HomeIcon from "@/components/homeIcon";
import RightCode from "../../components/rightCode.vue";
import SubBox from "@/components/subBox";
import WrongCard from "@/components/wrongCard.vue";
import ManageFooter from "@/components/manageFooter.vue";
import ImgDialog from "@/components/common/imgDialog.vue";
import api from "@/utils/api";

export default {
  components: {
    MpBox,
    HomeIcon,
    RightCode,
    SubBox,
    WrongCard,
    ManageFooter,
    ImgDialog
  },
  data() {
    return {
      wxPath: "/pages/detail/detail?qid=",
      showVersionTip: false,
      settingUrl: "",
      reg_required: 0,
      total_wrong_count: 0,
      wrong_book: 1,
      info: null,
      result: null,
      rid: "",
      award_run_way: 0,
      award_run_status: 0,
      isMobile: isMobile(),
      isWeixin: isWeixin(),
      isInApp: wemeet.app.isTMWebview(),
      settingSrc: "",
      show_answer: 0,
      theme_color: "#1890FF",
      theme_color_bg: "#1890FF",
      noChance: true,
      showShareImg: false,
      prurl: "",
      shareVisible: false,
      showShare: false,
      h5LinkTips: ["参与环境更聚焦-只展示本答题相关内容"],
      h5LinkTipsActive: [
        "该功能是高级版功能：",
        "基础版-进入H5页面仅展示活动详情，无法参与答题"
      ],
      url: `https://m.xiaoxiaodati.com/${
        api.baseUrl.indexOf("pre.") > 0 ? "test/" : ""
      }normal/detail?qid=`
    };
  },
  mounted() {
    this.rid = this.$route.query.rid;
    this.getInfo();
    setShareInfo(false);
  },
  methods: {
    toTool() {
      if(this.isInApp) {
        this.showVersionTip = true;
      }else {
        // 拼接 grant_count 参数
        let url = this.info.awards[0].h5_path;
        if (this.result.draws_total != null) {
          let sep = url.indexOf('?') !== -1 ? '&' : '?';
          url = url + sep + 'grant_count=' + this.result.draws_total;
        }
        if(this.isMobile) {
          localStorage.setItem('openWechat', 1)
          window.location.href = url;
        }else {
          window.open(url, "_blank");
        }
      }
    },
    async toMessage() {
      if (this.isMobile) {
        if (!this.settingUrl) {
          let res = await getWxUrl("pages/detail/detail", this.info.qid, 1);
          if (res) {
            this.settingUrl = res;
          }
        }
        window.location.href = this.settingUrl;
        return;
      } else {
        this.showVersionTip = true;
      }
    },
    copy() {},
    copySuccess() {
      Toast("复制成功");
    },
    handleShareVisible() {
      this.shareVisible = false;
    },
    share() {
      if (this.info.is_owner && this.isInApp) {
        window.wemeet.app.shareOpenApp();
      } else {
        // 先判断有没有登录
        if (!getToken()) {
          if (this.isInApp || this.isWeixin) {
            return this.handleErr("/normal/detail?qid=" + this.qid);
          } else {
            // 非微信或者腾讯会议环境
            this.getLoginCode(this.isMobile ? true : "");
            return;
          }
        } else {
          if (!this.info.allow_share && !this.info.is_owner) {
            Toast("出题人设置了不允许分享");
          } else {
            if (this.isInApp) {
              this.showShare = true;
            } else {
              this.shareVisible = true;
            }
          }
        }
      }
    },
    getLoginCode() {},
    handleErr() {},
    toSub() {
      window.location.href =
        "https://mp.weixin.qq.com/s/j9hHKHMYCZDZmulLZzql5w";
    },
    towronglist() {
      adClickReport("result_wrongbook_again", "成绩页错题重练");
      jumpWrongList(this);
    },
    wrongClick() {
      if (!this.wrong_book && this.show_answer == 1) {
        // 没开启错题本也将答案与解析隐藏了
        return;
      }
      if (!this.isInApp && this.wrong_book && this.result.wrong) {
        adClickReport("result_wrong_count");
        jumpWrongList(this);
      } else {
        this.toAnswer();
      }
    },
    toPcCreate() {
      window.open("https://xiaoxiaodati.com", "_blank");
    },
    toLottery() {
      if (!this.result.draws_count) {
        Toast("暂无抽奖机会");
      } else {
        this.$router.push({ name: "lottery", query: { qid: this.info.qid } });
      }
    },
    toRank() {
      this.$router.push({ name: "rank", query: { qid: this.info.qid } });
    },
    // 评论跳转至公众号
    toWebview() {
      let url = this.info.adv_comment.url;
      if (url) {
        window.location.href = this.info.adv_comment.url;
      }
    },
    toDo() {
      this.$router.push({
        name: "normalDetail",
        query: { qid: this.info.qid }
      });
    },
    toAnswer() {
      this.$router.push({
        name: "answerNormal",
        query: { rid: this.rid }
      });
    },
    getInfo() {
      let param = {
        rid: this.rid,
        access_token: getToken()
      };
      if(localStorage.getItem('openWechat')) {
        param.reload = randomString(6);
        localStorage.removeItem('openWechat')
      }
      questionOnly.get("/xcx/ques/v2/result", param).then(async res => {
        if (res.sta == 0) {
          this.info = res.data;
          this.setNavigationBarColor(res.data.theme_color || "#1890FF");
          this.result = res.data.submit_data;
          this.result.time = formatMinuteNew(res.data.submit_data.time);
          this.show_answer = res.data.show_answer;
          this.total_wrong_count = res.data.total_wrong_count;
          this.wrong_book = res.data.wrong_book;
          (this.reg_required = res.data.reg_required),
            this.judgeCount(res.data);
          if (res.data.award_type > 0) {
            this.handleAwards(res.data);
          }
          if (!this.isMobile) {
            this.settingSrc = await getDetailWxCode(this.info.qid);
          }
        } else if (res.sta == -500) {
          Toast(res.msg);
        } else if(res.sta == -1 && res.errcode == 129) {
          Dialog.confirm({
            title: "提示",
            message: res.msg,
            confirmButtonText: "我知道了",
            showCancelButton: false,
            confirmButtonColor: "#1890FF"
          })
            .then(() => {
              this.$router.go(-1);
            })
        }else {
          Toast(res.msg);
        }
      });
    },
    handleAwards(d) {
      this.award_run_way = d.award_run_way;
      this.award_run_status = d.award_run_status || 0;
      let _win = localStorage.getItem("_win");
      if (_win == 1) {
        if (d.award_type == 1) {
          this.$router.push({
            name: "lottery",
            query: { qid: this.info.qid }
          });
        } else {
          Dialog.confirm({
            title: "",
            message: "恭喜获得抽奖机会，点击前往",
            confirmButtonText: "去抽奖",
            confirmButtonColor: "#1890FF"
          })
            .then(() => {
              this.toTool();
            })
            .catch(() => {});
        }
      } else if (_win == 2) {
        let date_str = d.award_run_time;
        date_str = formatDate(date_str * 1000, "yyyy年MM月dd日 HH:mm");
        showModelTips(
          "已完成答题！\n将在" +
            date_str +
            " 时自动开奖，请留意开奖通知，不要错过哦",
          { confirmColor: "#fd4449", title: "等待开奖" }
        );
      } else if (_win == 3) {
        Dialog.confirm({
          title: "中奖次数已达上限",
          message:
            "已达到该活动领奖上限，请到答题主页查看详情，联系发起人兑奖。",
          confirmButtonText: "我知道了",
          cancelButtonText: "答题主页",
          confirmButtonColor: "#1890FF"
        })
          .then(() => {})
          .catch(() => {
            this.$router.go(-1);
          });
      } else if (_win == 4) {
        showModelTips("很遗憾，本次成绩未达到抽奖要求，再接再厉！", {
          confirmColor: "#fd4449",
          title: "差一点就中奖了"
        });
      } else if (_win == 5) {
        showModelTips("很遗憾，奖品已经被抽完了！", {
          confirmColor: "#fd4449",
          title: "差一点就中奖了"
        });
      }

      localStorage.removeItem("_win");
    },
    judgeCount(d) {
      let {
        max_join_count,
        share_add_count,
        allow_share_add,
        joined_count,
        today_joined_count,
        allow_share,
        join_status,
        wrong_book,
        submit_data,
        temp,
        max_join_type
      } = d;
      let info = {};
      if (max_join_type) {
        joined_count = today_joined_count;
        info.joined_count = today_joined_count;
      }
      // 答题次数为无限制 || 不允许分享
      if (
        d.temp == 3 ||
        max_join_count == 0 ||
        allow_share == 0 ||
        join_status != 2
      ) {
        info.factJoinStatus = join_status;
      } else {
        // 已设置为可允许通过分享添加答题次数
        let factMaxJoinCount = max_join_count + share_add_count; // 实际可答题次数
        if (
          (allow_share_add && share_add_count == 0) ||
          (allow_share_add && joined_count < factMaxJoinCount)
        ) {
          if (allow_share_add && joined_count < factMaxJoinCount) {
            info.factJoinStatus = 1;
          } else {
            info.factJoinStatus = 3;
          }
        } else {
          info.factJoinStatus = 2;
        }
        if (max_join_count == joined_count) {
          info.factJoinStatus = allow_share_add ? 3 : 2;
        }
      }
      this.noChance =
        temp != 3 &&
        wrong_book &&
        submit_data.wrong &&
        info.factJoinStatus != 1 &&
        !this.isInApp
          ? true
          : false;
    },
    setNavigationBarColor(color) {
      this.theme_color = color;
      this.theme_color_bg = `linear-gradient(0deg, rgba(${parseInt(
        color.slice(1, 3),
        16
      )}, ${parseInt(color.slice(3, 5), 16)}, ${parseInt(
        color.slice(5, 7),
        16
      )}, 0) 0%, ${color} 36%, ${color} 100%)`;
    }
  }
};
</script>

<style scoped lang="scss">
@function rem($px) {
  @return $px * 2 / 75 + rem;
}

.main {
  min-height: 100vh;
  color: #262626;
  padding-bottom: 85px;
  box-sizing: border-box;
  padding-bottom: env(safe-area-inset-bottom);
  .main-box {
    max-width: 500px;
    margin: 0 auto;
    position: relative;
    padding-bottom: 85px;
  }
  .back {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 280px;
    background-color: #1890ff;
    max-width: 500px;
    margin: 0 auto;
  }
  .content {
    min-width: 345px;
    margin: 0 auto 0;
    border-radius: 5px;
    position: relative;
    // padding-bottom: rem(15);
    line-height: 1;
    text-align: center;
    padding-top: 23px;
  }
  .name div {
    max-width: 326px;
    text-align: left;
    word-break: break-all;
  }
  @media screen and (max-width: 500px) {
    // 小于500
    .content {
      max-width: 460px;
    }
  }

  @media screen and (max-width: 450px) {
    // 小于450
    .content {
      max-width: 390px;
    }
  }

  @media screen and (max-width: 400px) {
    // 小于400
    .content {
      max-width: 360px;
    }
    .name div {
      max-width: 226px;
    }
  }
  @media screen and (max-width: 380px) {
    // 小于400
    .content {
      max-width: 350px;
    }
  }

  @media screen and (min-width: 500px) {
    // 大于500
    .content {
      max-width: 460px;
    }
  }

  .content-top {
  }
  .content-body {
    background-color: #fff;
    margin-top: 10px;
    border-radius: 6px;
  }
  .name {
    font-size: 15px;
    margin-left: 15px;
    display: flex;
    align-items: center;
  }


  .name img {
    width: 18px;
    height: 19px;
    padding: 7px;
  }

  .title {
    font-weight: bold;
    font-size: 17px;
    padding: 0 15px;
    line-height: 1.4;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    color: #262626;
  }
  .success-icon {
    width: 50px;
    height: 50px;
    object-fit: cover;
    margin-top: 20px;
    margin-bottom: 18px;
  }
  .time-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 64px;
    background: #fff;
    color: #262626;
    padding: 0 15px;
  }
  .time-box .left {
    color: #999999;
    font-size: 13px;
  }

  .score {
    font-weight: bold;
    font-size: 42px;
    margin: 20px 0 18px;
  }

  .avatar {
    width: 45px;
    height: 45px;
    border-radius: 50%;
    border: 2px solid #fff;
  }

  .all {
    color: #999;
    font-size: 13px;
  }
  .review-tip {
    font-size: 13px;
    text-align: center;
    border-radius: 0px 0px 6px 6px;
    background: #fffcef;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffb309;
    position: relative;
    top: -3px;
  }
  .postop {
    position: relative;
    top: -4px;
  }

  .detail {
    margin: auto;
  }
  .bottom,
  .top {
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
  }

  .top {
    padding: 20px 15px;
  }
  .top-view {
    flex: 1;
    justify-content: space-between;
    text-align: center;
  }
  .top-view:first-child {
    max-width: 65px;
  }
  @media screen and (min-width: 500px) {
    // 当屏幕宽度大于或等于 500px 时应用的样式规则
    .top-view:first-child {
      max-width: 85px;
    }
  }

  .bottom {
    padding: 15px 15px 20px;
    margin: 0 auto;
    border-top: 1px solid #ccc;
    /* width: 540rpx; */
  }

  .tip {
    font-size: 13px;
    color: #999;
    margin-top: 5px;
    line-height: 19px;
  }

  .big {
    font-size: 17px;
    font-weight: bold;
    line-height: 25px;
  }

  .action {
    position: relative;
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-top: 10px;
  }
  .action button {
    height: 45px;
    color: #ffffff;
    cursor: pointer;
  }
  .button {
    margin: 0;
    font-size: 16px;
  }
  .btn-group {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    button {
      flex: 1;
      border-radius: 4px;
    }
  }
  .btn {
    margin-bottom: rem(10);
  }
}
.black {
  color: #262626;
}
.half {
  flex: 1;
  margin-right: rem(10);
}
.ml20 {
  margin-left: rem(10);
}
.rightCode-btn {
  margin-top: 24px;
}
.rightCode-btn button {
  display: block;
  width: 100%;
  height: 48px;
  box-sizing: border-box;
  line-height: 48px;
  border-radius: 4px;
  font-size: 18px;
  color: #fff;
  cursor: pointer;
}
.rightCode-btn .toCreate {
  color: #1890ff;
  background: #ffffff;
  margin-top: 24px;
}
.usersInfo {
  display: flex;
  color: #fff;
}
.content-top-box {
  background-color: #ffffff;
  text-align: center;
  padding: 23px 15px 20px;
  border-radius: 6px;
  margin-top: 20px;
}
.footer {
  height: 65px;
  border: 1px solid #eee;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  z-index: 99;
  left: 0;
  right: 0;
  bottom: 0;
  box-sizing: content-box;
  padding-right: 15px;
  padding-bottom: env(safe-area-inset-bottom);
  min-width: 320px;
  max-width: 500px;
  margin: 0 auto;
  box-sizing: border-box;
}
.foot-item {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  cursor: pointer;
}
.foot-item.share {
  max-width: 70px;
  flex-direction: column;
  font-size: 12px;
  color: #666666;
}
.foot-item.second {
  border: 1px solid #1890ff;
  border-radius: 4px;
  color: #1890ff;
  height: 45px;
  margin-right: 10px;
  box-sizing: border-box;
}
.foot-item.third {
  background: #1890ff;
  border-radius: 4px;
  color: #ffffff;
  height: 45px;
  box-sizing: border-box;
}
.foot-share-icon {
  width: 22px;
  height: 22px;
  margin-bottom: 4px;
}
.shareimg-box {
  text-align: center;
  padding: 0 0 10px;
  img {
    width: 300px;
  }
  div {
    height: 30px;
    line-height: 30px;
    text-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
    color: #fff;
    font-size: 14px;
  }
}
.h5Link {
  background: #ffffff;
  box-sizing: border-box;
  font-size: 12px;
  position: relative;
  margin: 0 15px;
}

.h5Link-title {
  text-align: center;
  font-size: 17px;
  line-height: 25px;
  margin: 15px 0;
}

.h5Link-text {
  background: #f2f2f7;
  border-radius: 4px;
  padding: 10px;
  font-size: 15px;
  line-height: 21px;
  margin-bottom: 15px;
  word-break: break-all;
}

.h5Link-tip {
  font-size: 14px;
  line-height: 21px;
  color: #999;
  margin-bottom: 5px;
  display: flex;
  align-items: center;
}
.h5Link-tip-text {
  display: inline-block;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #999999;
  margin-right: 5px;
}

.h5Link-tipActive-box {
  margin: 10px 0 0;
}

.h5Link-tipActive {
  line-height: 21px;
  color: #fa9d3b;
}

.h5Link-btn {
  height: 43px;
  line-height: 43px;
  background: #1890ff;
  border-radius: 2px;
  color: #fff;
  text-align: center;
  font-size: 16px;
  margin: 15px 0;
}
.redColor {
  color: #ff7070;
}
.tools-award {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  background: #F6F6F6;
  padding: 10px;
  border-radius: 4px;
  margin-top: 10px;
}
.tools-award.comAd {
  margin-top: 1px;
}
.tools-icon {
  width: 45px;
  height: 45px;
  min-width: 45px;
  border-radius: 2px;
  margin-right: 10px;
}
.tools-name {
  flex: 1;
  margin-right: 10px;
  text-align: left;
}
.tools-lead {
  width: 97px;
  height: 25px;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #A8071A;
  color: #ffffff;
}
.mt0 {
  margin-top: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/normal/result.vue